import type { Photo } from '@/lib/types';
import { PhotoCard } from './photo-card';
import { Skeleton } from './ui/skeleton';
import { Camera } from 'lucide-react';

interface PhotoGridProps {
  photos: Photo[];
  loading: boolean;
  isMyPhotosTab?: boolean;
}

export function PhotoGrid({
  photos,
  loading,
  isMyPhotosTab = false,
}: PhotoGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-3 lg:grid-cols-4 gap-1 sm:gap-2 md:gap-4">
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} className="aspect-square rounded-xl" />
        ))}
      </div>
    );
  }

  if (photos.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center text-center py-20 border-2 border-dashed rounded-xl">
        <Camera className="h-16 w-16 text-muted-foreground/50 mb-4" />
        <h3 className="text-xl font-semibold text-muted-foreground">
          {isMyPhotosTab ? 'You have no photos yet' : 'No photos to display'}
        </h3>
        <p className="text-muted-foreground mt-2">
          {isMyPhotosTab
            ? 'Upload your first photo to see it here.'
            : 'Be the first to upload a photo for this event!'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 lg:grid-cols-4 gap-1 sm:gap-2 md:gap-4">
      {photos.map((photo) => (
        <PhotoCard key={photo.id} photo={photo} />
      ))}
    </div>
  );
}
